import {Component, OnInit, ViewChild} from '@angular/core';
import {UserRequest} from "../../domain/user-request";
import {Observable} from "rxjs/Observable";
import {UserRequestService} from "../../service/user-request.service";
import {ConfirmationService} from "primeng/primeng";
import {GlobalAppService} from "../../../core/commons/global-app.service";
import {MessageSeverity} from "../../../core/commons/message-severity";
import { MatTableDataSource, MatPaginator } from '@angular/material';
import {FormControl} from '@angular/forms';
import { merge } from 'rxjs/observable/merge';
import { QueryOptions } from 'app/core/commons/query.options';
@Component({
    selector: 'app-user-request',
    templateUrl: './user-request.component.html',
    styleUrls: ['./user-request.component.scss'],
    providers: [UserRequestService]
})
export class UserRequestComponent implements OnInit {

    data = new MatTableDataSource([]);
    displayedColumns = ["name", "email", "phone", "organism", "actions"];
    nameFilterControl: FormControl;
    emailFilterControl: FormControl;
    resultsLength: number;
    @ViewChild('paginator') paginator: MatPaginator;

    constructor(private userRequestService: UserRequestService,
                private confirmationService: ConfirmationService,
                private appService: GlobalAppService) {
    }

    ngOnInit() {
        this.paginator.pageSize = 10;
        this.nameFilterControl = new FormControl('');
        this.emailFilterControl = new FormControl('');
        merge(this.emailFilterControl.valueChanges.debounceTime(500),
              this.nameFilterControl.valueChanges.debounceTime(500))
            .subscribe(() => {
                this.paginator.pageIndex = 0;
                this.getData();
            })

        this.paginator.page.subscribe(() => this.getData());
        this.getData();

    }

    getData() {
        this.userRequestService.getPage(this.paginator.pageIndex, this.paginator.pageSize,
            this.nameFilterControl.value, this.emailFilterControl.value).subscribe(userRequestsPage => {
            this.data.data = userRequestsPage.content;
            this.resultsLength = userRequestsPage.totalElements;
        });
    }

    public approve(userReq: UserRequest) {
        this.confirmationService.confirm({
            message: '¿Está seguro que desea aprobar la solicutud?',
            icon: 'fa ui-icon-check',
            accept: () => {
                this.appService.setLoading(true);
                this.userRequestService.approveRequest(userReq)
                    .switchMap(() => this.userRequestService.getPage(this.paginator.pageIndex, this.paginator.pageSize,
                        this.nameFilterControl.value, this.emailFilterControl.value) )
                    .subscribe(
                        userRequestsPage => {
                            this.data.data = userRequestsPage.content;
                            this.resultsLength = userRequestsPage.totalElements;
                            this.appService.setLoading(false);
                            this.appService.sendMsg(MessageSeverity.SUCCESS, "La solicitud fue aprobada", "El usuario " +
                                userReq.firstname + " " + userReq.lastname + " fue incorparado a Abogados del Estado.");
                        },
                        error => {
                            this.appService.setLoading(false);
                            this.appService.sendMsg(MessageSeverity.ERROR, "Error", "No ha sido posible aprobar la solicitud.");
                        });
            }
        });
    }

    public reject(userReq: UserRequest) {
        this.confirmationService.confirm({
            message: '¿Está seguro que desea rechazar la solicutud?',
            icon: 'fa ui-icon-clear',
            accept: () => {
                this.appService.setLoading(true);
                this.userRequestService.rejectRequest(userReq)
                    .switchMap(() => this.userRequestService.getPage(this.paginator.pageIndex, this.paginator.pageSize,
                        this.nameFilterControl.value, this.emailFilterControl.value) )
                    .subscribe(
                        userRequestsPage => {
                            this.data.data = userRequestsPage.content;
                            this.resultsLength = userRequestsPage.totalElements;
                            this.appService.setLoading(false);
                            this.appService.sendMsg(MessageSeverity.SUCCESS, "La solicitud fue rechazada", "El usuario " +
                                userReq.firstname + " " + userReq.lastname + " no podra acceder a Abogados del Estado.");
                        },
                        error => {
                            this.appService.setLoading(false);
                            this.appService.sendMsg(MessageSeverity.ERROR, "Error", "No ha sido posible rechazar la solicitud.");
                        });
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/user-request/user-request.component.ts